import React from "react";
// mui 5
import Typography from "@mui/material/Typography";

function ErrorMessage({ msg }) {
  return <Typography variant="h6">{msg}</Typography>;
}

export default ErrorMessage;
